/*
  Lightweight, self-contained scroll-reveal for the custom "cyan-" sections.
  See cyan-reveal.css for the companion styles. Kept intentionally separate
  from the bundled theme.js reveal system (image-with-text-block, carousels,
  etc.), since that system's internals are private to specific pre-built
  component classes and aren't reusable from a plain inline script.
*/
(() => {
  const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const revealElement = (element, index) => {
    if (prefersReducedMotion) {
      element.classList.add('is-cyan-visible');
      return;
    }

    window.setTimeout(() => {
      element.classList.add('is-cyan-visible');
    }, Math.min(index, 6) * 80);
  };

  const groupByContainer = (elements) => {
    const groups = new Map();

    elements.forEach((element) => {
      const container = element.closest('[data-cyan-reveal-group]') || element.parentElement;
      if (!groups.has(container)) {
        groups.set(container, []);
      }
      groups.get(container).push(element);
    });

    return groups;
  };

  const init = () => {
    const elements = Array.from(document.querySelectorAll('[data-cyan-reveal]'));

    if (!elements.length) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-cyan-visible'));
      return;
    }

    const groups = groupByContainer(elements);
    const indexByElement = new Map();
    groups.forEach((groupElements) => {
      groupElements.forEach((element, index) => indexByElement.set(element, index));
    });

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            revealElement(entry.target, indexByElement.get(entry.target) || 0);
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '30px 0px', threshold: 0 }
    );

    elements.forEach((element) => observer.observe(element));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
